import { Spinner } from 'construct-ui';
import AvatarImg from '../../static/images/user/avatar.png';
import languageModel from '../models/language.model';
import loginModel from '../models/login.model';
import navigationModel from '../models/navigation/navigation.model';
import profileModel from "../models/profile.model";
import POSMAuthorityModel from '../models/posm/posm-authority.model';

export default function HeaderLayout() {
  const WebAppTitle = 'Samsung MCS';
  let languageList = [];
  let countryList = [];

  let selectedCountryCode = '';
  let pendingSwitchCountry = null;
  let isRefreshing = false;

  let _getLanguageList = (e) => {
    languageModel.getLanguages(
      _getLanguageListSuccessCallBack,
      _getLanguageListFailureCallBack
    );
  }

  let _getCountryList = (e) => {
    languageModel.getCountries(
      (result) => {
        countryList = result;
      },
      (error) => {
        console.error("get country list call back error:" + JSON.stringify(error));
      }
    );
  }

  let _getLanguageListSuccessCallBack = (result) => {
    languageList = result;
    languageList.forEach(function (language) {
      language.fullCode = language.code; // Preserve full code (e.g. th-TH)
      let arr = language.code.split('-'); // From the code master get the code as xx-XX(th-TH).So need to get first two character as the language code
      language.code = arr[0];
      if (loginModel.credentials.language == language.code) {
        language.checked = true;
      } else {
        language.checked = false;
      }
    });
  }

  let _getLanguageListFailureCallBack = (err) => {
    console.error("getLanguageListFailureCallBack:" + JSON.stringify(err));
  }

  let _logout = () => {
    loginModel.logout()
  }

  let _goResetPassword = (e) => {
    m.route.set("/reset");
  }

  let _goTouserProfile = (e) => {
    m.route.set("/user-profile");
  }

  const getProfile = (redraw) => {
    // background = true, So that mithril doesn't auto-redraw on request complete
    return profileModel.getProfile({ background: !redraw })
      .catch((error) => {
        console.error('Error in getting profile', error);
      });
  }

  const getActiveMenuList = () => {
    // background = true, So that mithril doesn't auto-redraw on request complete
    return navigationModel.getActiveMenuList({ background: true })
      .catch(error => {
        console.error('Failed to retrieve active menu list', error);
      })
  }

  const getPOSMAuthority = (redraw) => {
    return POSMAuthorityModel.getAuthorityUserByIDList({ background: !redraw })
      .catch(error => {
        console.error('Failed to retrieve POSM Authority', error);
      })
  }

  const _switchCountry = (countryCode) => {
    if (countryCode) {
      pendingSwitchCountry = profileModel.switchCountry(countryCode)
        .then(() => {
          selectedCountryCode = countryCode
        }).catch(error => {
          console.error('Error in switch country', error);
        }).finally(() => {
          pendingSwitchCountry = null;
        });
      return pendingSwitchCountry;
    }
  }

  const _switchLanguage = (language) => {
    if (language.fullCode) {
      return profileModel.switchLanguage(language).catch(error => {
        console.error('Error in switch language', error);
      })
    }
  }

  return {
    oninit: function () {
      _getCountryList();
      _getLanguageList();
      if (!loginModel.profileDetails)
        getProfile(true);
      if (!POSMAuthorityModel.posmAuthority) {
        getPOSMAuthority(true)
      }
    },
    onupdate: function () {
      // Put in onupdate to delay the call to the next redraw
      // so that the spinner can be redrawn with visibility first
      if ((selectedCountryCode !== '' || pendingSwitchCountry) && !isRefreshing) {
        isRefreshing = true;
        const countryCode = selectedCountryCode || loginModel.credentials.country;
        selectedCountryCode = '';

        const switchDone = pendingSwitchCountry ?? Promise.resolve();
        switchDone.then(() => {
          loginModel.credentials.country = countryCode;
          loginModel.setCountry(countryCode);

          Promise.allSettled([getProfile(), getActiveMenuList(), getPOSMAuthority()])
            .finally(() => {
              isRefreshing = false;
              m.route.set(m.route.get());
            });
        });
      }
    },
    view: function (vnode) {
      return [
        m('header.header.shadow-sm',
          [
            // Title - Appear only in small screen
            m('.small-screen-title', WebAppTitle),
            // Title & Menu toggle
            m('.left-side[id="left-side"]',
              m('div.nav_logo.gap-3',
                m('a.mobile-menu2[href="javascript:"][id="header-toggle"]',
                  m("span")
                ),
                m('.title', WebAppTitle),
              )
            ),
            // Top nav - menu items
            m('.right-side.is-flex',
              [
                m('.top-menu-left'),
                m('.top-menu-right',
                  m('.navbar-expand.pe-4.me-1',
                    m('ul.navbar-nav.gap-2',
                      [
                        m('li.nav-item.dropdown.my-auto',
                          m('a.nav-link', {
                            href: 'http://itvoc.sec.samsung.net/it4u/voc/vocReg?directCode=08P0271X006631',
                            target: '_blank'
                          }, 'Global ITVOC'),
                        ),
                        m('li.nav-item.dropdown.my-auto', [
                          m('a.nav-link.d-flex.align-items-center.gap-2[href="#languageDrodownOption"][role="button"][data-bs-toggle="dropdown"][aria-expanded="false"]',
                            loginModel.credentials.languageName,
                            m('i.bi-chevron-down'),
                          ),
                          m('ul.dropdown-menu.dropdown-menu-sm-end[id="languageDrodownOption"]',
                            languageList.map((language) => [
                              m("li",
                                {
                                  onclick: (e) => {
                                    language.checked = !language.checked;
                                    if (language.checked == true) {
                                      languageList.forEach(function (language2) {
                                        if (language2.code != language.code) {
                                          language2.checked = false;
                                        }
                                      });
                                      _switchLanguage(language)
                                    }
                                  }
                                },
                                m('a.dropdown-item[role="button"]', language.name)
                              )
                            ])
                          )
                        ]),
                        m('li.nav-item.dropdown.my-auto', [
                          loginModel?.credentials?.country &&
                          m('a.nav-link.d-flex.align-items-center.gap-2[href="#countryDrowdownOption"][role="button"][data-bs-toggle="dropdown"][aria-expanded="false"]',
                            m(`i.flag-icon.flag-icon-${loginModel.credentials.country.toUpperCase()}`),
                            loginModel.credentials.country.toUpperCase(),
                            m('i.bi-chevron-down')
                          ),
                          m('ul.dropdown-menu.dropdown-menu-sm-end[id="countryDrowdownOption"]',
                            countryList.map(function (country) {
                              return m("li", { onclick: (e) => _switchCountry(country.code) },
                                m('a.dropdown-item[role="button"]', m(`i.flag-icon.me-1.flag-icon-${country.code}`), country.code)
                              )
                            })
                          )
                        ]),
                        m('li.nav-item.dropdown.my-auto', [
                          m('a.nav-link.d-flex.align-items-center.gap-2[href="#userDrodownOption"][role="button"][data-bs-toggle="dropdown"][aria-expanded="false"]',
                            m('img.img-responsive.user-avatar', { "src": loginModel.profileDetails?.photoString || AvatarImg }),
                            m('i.bi-chevron-down')
                          ),
                          m('ul.dropdown-menu.dropdown-menu-sm-end[id="userDrodownOption"]',
                            [
                              m('li',
                                m('a.dropdown-item[role="button"]', { onclick: _goTouserProfile }, m('i.bi.bi-person'), languageModel.getText("LT00000187", "User Profile"))
                              ),
                              m('li',
                                m('a.dropdown-item[role="button"]', { onclick: _goResetPassword }, m('i.bi.bi-unlock'), languageModel.getText("LT00000032", "Reset Password"))
                              ),
                              m('li',
                                m('a.dropdown-item[role="button"]', { onclick: _logout }, m('i.bi-box-arrow-right'), languageModel.getText("LT00000812", "Logout"))
                              ),
                            ]
                          )
                        ]),
                      ]
                    )
                  )
                )
              ]
            )
          ]
        ),
        m(Spinner, {
          active: selectedCountryCode !== '',
          background: true,
          fill: true,
          size: 'xl',
          style: {
            zIndex: '1000'
          }
        })
      ];
    },
  };
}